import React from 'react';
import Icon from '../../Icon.tsx';
import IconOpenInNew from '../../../icons/IconOpenInNew.tsx';

interface CheckLocalDisruptionsProps {
    handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleContinue: () => void;
    isChecked: boolean;
}

const CheckLocalDisruptionsComponent: React.FC<CheckLocalDisruptionsProps> = ({
        handleCheckboxChange,
        handleContinue,
        isChecked,
    }) => {
    return (
        <div className={'selfcare-report-error-form'}>
            <h2 className={'heading heading--montserrat'}>Før du kan fejlmelde</h2>
            <p>
                Tjek først om der er driftsforstyrrelser i dit område på knappen nedenunder.
                Linket åbner i en ny fane, så du let kan komme tilbage til denne side.
            </p>
            <p className={'align-center pb-full'}>
                <a
                    className={'button button--montserrat gray rounded with-icon'}
                    href={'https://drift.hiper.dk'}
                    target={'_blank'}
                >
                    <span className={'text'}>
                        Åbn driftsstatus i ny fane
                    </span>
                    <Icon component={IconOpenInNew} />
                </a>
            </p>
            <p className={'with-checkbox pb-double'}>
                <input
                    type="checkbox"
                    id="completed-troubleshooting"
                    required
                    onChange={handleCheckboxChange}
                />
                <label
                    htmlFor="completed-troubleshooting"
                    className="checkbox-label checkbox-label--montserrat"
                >
                    Jeg har tjekket, og der er ikke drifts&shy;forstyrrelser i mit område.*
                </label>
            </p>
            <div className={'navigation-buttons'}>
                <button
                    className={'button teal fejlmelding-fortsat'}
                    onClick={handleContinue}
                    disabled={!isChecked}
                >
                    Fortsæt
                </button>
            </div>
        </div>
    );
};

export default CheckLocalDisruptionsComponent;
